document.addEventListener('DOMContentLoaded', function () {


  var searchForm = document.querySelector('.search-form');
  var searchFormInput = searchForm ? searchForm.querySelector('input') : null;

  document.querySelectorAll('.search-open').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchForm) {
        searchForm.classList.remove('invisible', 'opacity-0');
        setTimeout(function () {
          if (searchFormInput) searchFormInput.focus();
        }, 500);
      }
    });
  });

  document.querySelectorAll('.search-close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchForm) searchForm.classList.add('invisible', 'opacity-0');
    });
  });

  document.querySelectorAll('.js-intl-menu-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var menu = document.querySelector('.intl-menu');
      var veil = document.querySelector('.intl-menu__veil');
      var header = document.querySelector('.site-header');
      var main = document.querySelector('main');
      if (!menu) return;

      var isInverted = header && header.classList.contains('site-header--inverted');

      if (
        menu.classList.contains('active') &&
        window.scrollY <= 30 &&
        window.location.pathname === '/'
      ) {
        if (header) header.classList.add('site-header--inverted');
      }

      if (
        menu.classList.contains('active') ||
        trigger.classList.contains('active') ||
        (veil && veil.classList.contains('active'))
      ) {
        if (main) {
          main.style.overflow = 'auto';
          main.style.height = 'auto';
        }
      } else {
        if (main) {
          main.style.overflow = 'hidden';
          main.style.height = 'calc(100dvh - 30px)';
        }
      }

      menu.classList.toggle('active');
      trigger.classList.toggle('active');
      if (veil) veil.classList.toggle('active');

      if (isInverted && header) {
        header.classList.remove('site-header--inverted');
      }
    });
  });

  document.querySelectorAll('.intl-menu__link').forEach(function (link) {
    link.addEventListener('click', function () {
      var country = link.dataset.country;
      if (country) localStorage.setItem('teddy-intl', country);
    });
  });

  if (
    window.location.href.includes(
      '/tools/emails/click/gift-card-created/13/button/view-gift-card?'
    )
  ) {
    var container = document.getElementById('oe-link-container');
    if (container) {
      var link = container.querySelector('a');
      if (link) window.location.href = link.innerText;
    }
  }

  function resetHeader(header) {
    var activeBanner = document.querySelector('.banner__content.active');

    if (activeBanner && activeBanner.dataset.headerStyle === 'solid_black') {
      if (!header.classList.contains('toggle--open')) {
        header.classList.add('site-header--dark');
      }
    } else if (
      activeBanner &&
      activeBanner.dataset.headerStyle === 'solid_white'
    ) {
      header.classList.remove('site-header--dark');
      header.classList.remove('site-header--inverted');
    } else {
      if (!header.classList.contains('toggle--open')) {
        header.classList.add('site-header--inverted');
      }
    }
  }

  document.querySelectorAll('.site-nav__link').forEach(function (navLink) {
    var parent = navLink.parentNode;
    var hasMenu = parent.classList.contains('has-menu');

    navLink.addEventListener('mouseover', function () {
      var header = document.querySelector('.site-header');
      if (!header) return;

      if (hasMenu) {
        var menu = parent.querySelector('.nav-menu-container');
        var menuVeil = parent.querySelector('.nav-menu-veil');
        if (menu) {
          menu.setAttribute('open', true);
          menu.setAttribute('aria-hidden', false);
        }
        navLink.setAttribute('aria-expanded', true);
        if (menuVeil) menuVeil.setAttribute('open', true);
      }

      if (!header.classList.contains('toggle--open')) {
        header.classList.add('toggle--open');
      }
      header.classList.remove('site-header--inverted');
      header.classList.remove('site-header--dark');
    });

    navLink.addEventListener('mouseout', function (e) {
      var header = document.querySelector('.site-header');
      if (!header) return;

      if (!hasMenu) {
        header.classList.remove('toggle--open');
        resetHeader(header);
        return;
      }

      var menu = parent.querySelector('.nav-menu-container');
      if (
        parent === (e.relatedTarget && e.relatedTarget.parentNode) ||
        (menu && !menu.matches(':hover'))
      ) {
        var menuVeil = parent.querySelector('.nav-menu-veil');
        if (menu) {
          menu.removeAttribute('open');
          menu.setAttribute('aria-hidden', true);
        }
        navLink.setAttribute('aria-expanded', false);
        if (menuVeil) menuVeil.removeAttribute('open');
        resetHeader(header);
      } else {
        header.classList.remove('site-header--inverted');
        header.classList.remove('site-header--dark');
      }
    });

    navLink.addEventListener('focus', function () {
      var header = document.querySelector('.site-header');
      if (!header) return;

      if (hasMenu) {
        var menu = parent.querySelector('.nav-menu-container');
        var menuVeil = parent.querySelector('.nav-menu-veil');
        if (menu) {
          menu.setAttribute('open', true);
          menu.setAttribute('aria-hidden', false);
        }
        navLink.setAttribute('aria-expanded', true);
        if (menuVeil) menuVeil.setAttribute('open', true);
      }

      if (!header.classList.contains('toggle--open')) {
        header.classList.add('toggle--open');
      }
      header.classList.remove('site-header--inverted');
      header.classList.remove('site-header--dark');
    });

    navLink.addEventListener('focusout', function (e) {
      if (parent.contains(e.relatedTarget)) return;
      var header = document.querySelector('.site-header');
      if (!header) return;

      if (!hasMenu) {
        header.classList.remove('toggle--open');
        resetHeader(header);
        return;
      }

      var menu = parent.querySelector('.nav-menu-container');
      if (
        parent === (e.relatedTarget && e.relatedTarget.parentNode) ||
        (menu && !menu.matches(':hover'))
      ) {
        var menuVeil = parent.querySelector('.nav-menu-veil');
        if (menu) {
          menu.removeAttribute('open');
          menu.setAttribute('aria-hidden', true);
        }
        navLink.setAttribute('aria-expanded', false);
        if (menuVeil) menuVeil.removeAttribute('open');
        resetHeader(header);
      } else {
        header.classList.remove('site-header--inverted');
        header.classList.remove('site-header--dark');
      }
    });

    navLink.addEventListener('keydown', function (e) {
      if (e.which === 13 && hasMenu) {
        e.preventDefault();
        var menu = parent.querySelector('.nav-menu-container');
        var menuVeil = parent.querySelector('.nav-menu-veil');
        if (menu) menu.removeAttribute('open');
        if (menuVeil) menuVeil.removeAttribute('open');
      }
    });
  });

  document.querySelectorAll('.nav-menu-container').forEach(function (menu) {
    menu.addEventListener('mouseout', function (e) {
      if (e.relatedTarget && menu.contains(e.relatedTarget)) return;

      var parent = menu.parentNode;
      var menuVeil = parent.querySelector('.nav-menu-veil');
      var header = document.querySelector('.site-header');
      var navLink = parent.querySelector('.site-nav__link');

      menu.removeAttribute('open');
      menu.setAttribute('aria-hidden', true);
      if (menuVeil) menuVeil.removeAttribute('open');
      if (header && !header.classList.contains('cart--open')) {
        header.classList.remove('toggle--open');
      }
      if (header) resetHeader(header);
    });

    menu.addEventListener('focusout', function (e) {
      if (e.relatedTarget && menu.contains(e.relatedTarget)) return;

      var parent = menu.parentNode;
      var menuVeil = parent.querySelector('.nav-menu-veil');
      var header = document.querySelector('.site-header');
      var navLink = parent.querySelector('.site-nav__link');

      menu.removeAttribute('open');
      menu.setAttribute('aria-hidden', true);
      if (navLink) navLink.setAttribute('aria-expanded', false);
      if (menuVeil) menuVeil.removeAttribute('open');
      if (header && !header.classList.contains('cart--open')) {
        header.classList.remove('toggle--open');
      }
      if (header) resetHeader(header);
    });
  });

  document.querySelectorAll('.trigger-live-chat').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (typeof LiveChatWidget !== 'undefined') {
        LiveChatWidget.call('maximize');
      }
    });
  });

});
